export function displayProductName(name) {
  if (!name) return "";
  return name.replace(/^LoftPress\s+/i, "").trim();
}
